var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"text-center"},[(_vm.template)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.template)}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.text)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }